import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { SERVER_URL } from "../../api";
import logoMedical from "../../assets/logo-medical.png";
import NextButton from "../../components/NextButton";
import PatientAvatar from "../../components/PatientAvatar";
import { useGameTexts } from "../../hooks/useGameTexts";
import { ROUTES } from "../../utils/constants";
import { getScenarioByScreen } from "../../utils/helpers";

function buildImageUrl(value) {
	if (!value || typeof value !== "string") return null;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

const DEFAULT_TITLE = "Parece evidente que hay que modificar<br/>el tratamiento a Martina.";
const DEFAULT_CONTENT = "De hecho, aunque a Martina se le ha prescrito un tratamiento con doble terapia, teniendo en cuenta sus datos y las recomendaciones de las guías, <span class=\"bold\">se podría haber iniciado un tratamiento de primera línea directamente con triple terapia</span>. Veamos el algoritmo que propone el documento de consenso GLOSEN 2023<sup>1</sup>";

function Scenario5End({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const group = useSelector((state) => state.group);
	const scenarioNum = getScenarioByScreen(location.pathname);
	const { texts, ready } = useGameTexts(group?.game);
	const title = texts["scenario5.end.title"] ?? DEFAULT_TITLE;
	const content = texts["scenario5.end.content"] ?? DEFAULT_CONTENT;

	// Precargar imágenes de scenario5.2-intro y scenario5.2-intro2 para que al llegar carguen al instante
	useEffect(() => {
		if (!ready) return;
		const introPath = texts["scenario5.2.intro.image"];
		const intro2Path = texts["scenario5.2.intro2.image"];
		if (introPath) {
			const u = buildImageUrl(introPath);
			if (u) { const img = new Image(); img.src = u; }
		}
		if (intro2Path) {
			const u = buildImageUrl(intro2Path);
			if (u) { const img = new Image(); img.src = u; }
		}
	}, [ready, texts["scenario5.2.intro.image"], texts["scenario5.2.intro2.image"]]);

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} alt="" />
				</div>
				<div className="row d-flex justify-content-center align-items-center mt-5">
					<div className="col-9">
						<div className="d-flex flex-column align-items-center">
							{!ready ? (
								<div style={{ width: 90, height: 90, borderRadius: "50%", background: "#e8e8e8" }} aria-hidden />
							) : (
								<PatientAvatar gameId={group?.game} width={90} />
							)}
							<div
								className="txt30 bold txt-yellow-light mt-4 text-center"
								style={{ lineHeight: "40px" }}
								dangerouslySetInnerHTML={{ __html: title }}
							/>
							<div
								className="text-center txt-white mt-3 px-5"
								dangerouslySetInnerHTML={{ __html: content }}
							/>
						</div>
					</div>
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "8vh",
				}}
			>
				<div className="d-flex justify-content-end">
					<NextButton
						navigateTo={ROUTES.SCENARIO5_PART2_INTRO}
						activeScenario={scenarioNum + 1}
					/>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario5End);
